var _CARD_TYPES_TO_CSS_MA;function _objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i] != null ? arguments[i] : {};var ownKeys = Object.keys(source);if (typeof Object.getOwnPropertySymbols === 'function') {ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {return Object.getOwnPropertyDescriptor(source, sym).enumerable;}));}ownKeys.forEach(function (key) {_defineProperty(target, key, source[key]);});}return target;}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target, props) {for (var i = 0; i < props.length; i++) {var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);}}function _createClass(Constructor, protoProps, staticProps) {if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;}function _defineProperty(obj, key, value) {if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;}import './payment-form-directives';
import './payment-form.scss';
import template from './payment-form.html';

import { types as CARD_TYPES } from 'credit-card-type';

var CARD_TYPES_TO_CSS_MAP = (_CARD_TYPES_TO_CSS_MA = {}, _defineProperty(_CARD_TYPES_TO_CSS_MA,
CARD_TYPES.VISA, "card-icon-visa"), _defineProperty(_CARD_TYPES_TO_CSS_MA,
CARD_TYPES.MASTERCARD, "card-icon-mastercard"), _defineProperty(_CARD_TYPES_TO_CSS_MA,
CARD_TYPES.AMERICAN_EXPRESS, "card-icon-american-express"), _defineProperty(_CARD_TYPES_TO_CSS_MA,
CARD_TYPES.DINERS_CLUB, "card-icon-diners"), _defineProperty(_CARD_TYPES_TO_CSS_MA,
CARD_TYPES.DISCOVER, "card-icon-discover"), _defineProperty(_CARD_TYPES_TO_CSS_MA,
CARD_TYPES.JCB, "card-icon-jcb"), _defineProperty(_CARD_TYPES_TO_CSS_MA,
CARD_TYPES.MAESTRO, "card-icon-maestro"), _defineProperty(_CARD_TYPES_TO_CSS_MA, "default",
'pf pf-credit-card'), _defineProperty(_CARD_TYPES_TO_CSS_MA, "get", function get(
type) {return this[type] || this.default;}), _CARD_TYPES_TO_CSS_MA);


export var PaymentFormComponent = {
  template: template,
  bindings: {
    needUserInfo: '<',
    submitButtonText: '@buttonText',
    onValid: '&',
    loading: "=?",
    success: '<',
    needTerms: "<",
    needUserEmail: '<' },

  controller: /*#__PURE__*/function () {PaymentFormComponentController.$inject = ["$element", "$scope"];
    function PaymentFormComponentController($element, $scope) {
      "ngInject";_classCallCheck(this, PaymentFormComponentController);
      this.$element = $element;
      this.$scope = $scope;

      this.showValidation = false;
      this.loading = false;
      this.success = false;
      this.terms = false;

      this.card = {
        number: '',
        cvv: '',
        expiry: '' };


      this.customer = {
        firstName: '',
        lastName: '' };


      this.user = {};

      this.handlerOnFocus = function (event) {
        var parent = angular.element(event.currentTarget).parent().parent();
        parent.attr('class', "controls is-focus");
      };

      this.handlerOnBlur = function (event) {
        var parent = angular.element(event.currentTarget).parent().parent();
        parent.attr('class', "controls is-blur ".concat(event.currentTarget.className));
      };

    }_createClass(PaymentFormComponentController, [{ key: "$onInit", value: function $onInit()

      {} }, { key: "onSubmit", value: function onSubmit(

      $event) {
        console.log('submit', $event);
        this.showValidation = true;

        if (this.isValid()) {
          if (this.needTerms && !this.terms) {
            return false;
          } else
          {
            this.loading = true;
            var result = this.serealize();
            console.warn('isValid!', result);
            this.onValid({ result: result });
          }
        }

      } }, { key: "isValid", value: function isValid()

      {
        return this.paymentForm.$valid;
      } }, { key: "serealize", value: function serealize()

      {
        if (this.needUserInfo && !this.needUserEmail) {
          return _objectSpread({}, this.card, this.customer);
        } else
        if (this.needUserEmail) {
          return _objectSpread({}, this.card, this.customer, this.user);
        } else
        {
          return _objectSpread({}, this.card);
        }
      } }, { key: "getIconClass", value: function getIconClass(

      type) {
        return CARD_TYPES_TO_CSS_MAP.get(type);
      } }]);return PaymentFormComponentController;}() };




angular.module('gplans.store').
component('paymentForm', PaymentFormComponent);